<template>
  <div>
    <div
      :class="{disabled: !ageRequirement}"
      tabindex="-1"
      @click.capture="handlePrevent"
    >
      <slot>
        empty
      </slot>
    </div>
    <div :class="{highlight: !ageRequirement}">
      <label>
        <input
          v-model="ageRequirement"
          type="checkbox"
        >
        I am at least 18 years old
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgeRequirement',
  data() {
    return {
      ageRequirement: null,
    };
  },
  methods: {
    handlePrevent(e) {
      if (!this.ageRequirement) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
  },
};
</script>

<style scoped>
.disabled {
  opacity: 0.6;
}
.highlight {
  font-weight: bold;
}
</style>
